const DEFAULT_SOCIAL_LINKS = [
  {
    title: 'LinkedIn',
    subtitle: 'Follow us for updates',
    description: 'Stay connected with BooksComply on LinkedIn for industry insights, company updates, and professional networking opportunities.',
    buttonText: 'Follow on LinkedIn',
    url: 'https://www.linkedin.com/company/bookscomply',
    icon: 'LuLinkedin',
    brandColor: '#0077B5',
    isActive: true,
    order: 0,
  },
  {
    title: 'Twitter / X',
    subtitle: 'Latest tweets & updates',
    description: 'Follow @BooksComply on Twitter for quick tips, tax updates, and engaging content about financial compliance.',
    buttonText: 'Follow on X',
    url: 'https://twitter.com/bookscomply',
    icon: 'LuTwitter',
    brandColor: '#000000',
    isActive: true,
    order: 1,
  },
];

const mapSocialItem = (item, index) => ({
  title: item.title || '',
  subtitle: item.subtitle || '',
  description: item.description || '',
  buttonText: item.buttonText || 'Visit',
  url: item.url || '',
  icon: item.icon || 'LuGlobe',
  brandColor: item.brandColor || '#3b82f6',
  isActive: item.isActive !== false,
  order: item.order ?? index,
});

const buildLegacySocialLinks = (content) => {
  const legacy = [];
  if (content?.linkedin) {
    legacy.push(mapSocialItem({
      title: content.linkedin.title || 'LinkedIn',
      subtitle: content.linkedin.subtitle || 'Follow us for updates',
      description: content.linkedin.description || '',
      buttonText: content.linkedin.buttonText || 'Follow on LinkedIn',
      url: content.linkedin.url || 'https://www.linkedin.com/company/bookscomply',
      icon: content.linkedin.icon || 'LuLinkedin',
      brandColor: content.linkedin.brandColor || '#0077B5',
      isActive: true,
      order: 0,
    }, 0));
  }
  if (content?.twitter) {
    legacy.push(mapSocialItem({
      title: content.twitter.title || 'Twitter / X',
      subtitle: content.twitter.subtitle || 'Latest tweets & updates',
      description: content.twitter.description || '',
      buttonText: content.twitter.buttonText || 'Follow on X',
      url: content.twitter.url || 'https://twitter.com/bookscomply',
      icon: content.twitter.icon || 'LuTwitter',
      brandColor: content.twitter.brandColor || '#000000',
      isActive: true,
      order: 1,
    }, 1));
  }
  return legacy;
};

export const normalizeSocialLinks = (content) => {
  let links;
  if (Array.isArray(content?.socialLinks) && content.socialLinks.length > 0) {
    links = content.socialLinks.map(mapSocialItem);
  } else {
    const legacy = buildLegacySocialLinks(content);
    links = legacy.length > 0 ? legacy : DEFAULT_SOCIAL_LINKS.map(mapSocialItem);
  }
  return links
    .filter((item) => item.isActive !== false)
    .sort((a, b) => (a.order || 0) - (b.order || 0));
};
